module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAApklEQVQoU3XQOQoCQRSE4b/wcCYKLiAGog6YKR5nUHDFQFwST2HgdQTDkh56Bmm10/5edfWT7Ry4Szrw49huA03ZzoANMEyx7RZwBeYKIbZHwO4Tx6RLgaS8gAnuA0/gVqJwX8GIA9rG2ZmkdRmUwkbsVAMGkk5f0HYHCJ0mwAs4AmNJ++pp213gDEwlLZLOBQ7r6cXpCv34YBbgCnhIWv5ZeFhd/Q3UA1ANlCDN7AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/close.png
// module id = 1Yzi
// module chunks = 2